import { render, staticRenderFns } from "./Highqualitydeclaration.vue?vue&type=template&id=4e08f48c&scoped=true"
import script from "./Highqualitydeclaration.vue?vue&type=script&lang=js"
export * from "./Highqualitydeclaration.vue?vue&type=script&lang=js"
import style0 from "./Highqualitydeclaration.vue?vue&type=style&index=0&id=4e08f48c&prod&lang=less&scoped=true"
import style1 from "./Highqualitydeclaration.vue?vue&type=style&index=1&id=4e08f48c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e08f48c",
  null
  
)

export default component.exports